// extracted by mini-css-extract-plugin
export var aboutContinueSectionLeftWrapper = "index-module--about-continue-section-left-wrapper--MKJ3O";
export var index = "index-module--index--3L-QL";
export var lastSection = "index-module--last-section--6HIsn";
export var mainSection = "index-module--main-section--GFwOI";
export var postTitles = "index-module--post-titles--CVRzg";
export var postTitlesContainer = "index-module--post-titles-container--9sf-W";
export var quoteSection = "index-module--quote-section--iQCAW";